import React from 'react';

export function Footer() {
  return (
    <>
      <div className="py-6 border-t-4 border-blue-300 mt-24">
        <p className="text-center text-white">
          Made with ❤️ by{' '}
          <a href="https://www.linkedin.com/in/samarjit-mahi/">
            {' '}
            Samarjit Mahi
          </a>
        </p>
      </div>
    </>
  );
}
